import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { ButtonComponent } from "../../components/elements";
import PageLayout from "../../layouts/PageLayout";

// import Editor from 'react-simple-wysiwyg';
import { toast } from 'react-toastify';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import { EditorState, ContentState,convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { addSimContractImage, getSettings, setSetting } from "../../APIs/SettingRequests";
export default function SimContractTemplate() {

    const { t } = useContext(TranslatorContext);
    const [html, setHtml] = useState('my <b>HTML</b>');
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    function onChange(e) {
      setHtml(e.target.value);
    }

    useEffect(()=> {
        getSettingsAction();
    },[]);
    
    const getSettingsAction = () => {
        getSettings().then((res) => {
            //console.log('res', res.data.data);
            const setting = res.data.data.find((item) => item.key === 'sim_contract_template');
            if(setting) {
                setEditorState(loadHtmlToEditor(setting.value));
            }
        })
        .catch((error) => {
            console.log('error', error);
        });
    }


    function loadHtmlToEditor(html) {
        const blocksFromHtml = htmlToDraft(html);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        return EditorState.createWithContent(contentState);
      }
    const uploadImageCallBack = async(file) => {        
        return new Promise(async(resolve, reject) => {
          const base64String = await convertImageToBase64(file);
          addSimContractImage(base64String).then((res) => {
            //console.log('res', res.data.data.url);
            resolve({ data: { link: res.data.data.url } });
          }).catch((error) => {
            console.log('error', error);
            reject(error);
          });
        });
      };


      function convertImageToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          
          reader.readAsDataURL(file);
        });
      }
      const handleUpdateButton = () => {
        const contentState = editorState.getCurrentContent();
        const rawContentState = convertToRaw(contentState);
        const htmlContent = draftToHtml(rawContentState);
        console.log('html', htmlContent);
        setSetting('sim_contract_template', htmlContent).then((res) => {
            const notify = () => toast.success(res.data.message);
            notify();
        }
        ).catch((error) => {
            console.log('error', error);
        });

      }
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('sim_contract_template')}</h3>
                        </div>
                    </div>
                </Col>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-tab-card">
                            <h4 className="mc-tab-card-title">{t('variables_names')}</h4>
                            <p className="mc-tab-card-text">{'{{customer_name}} => Customer Name'}</p>
                            <p className="mc-tab-card-text">{'{{customer_address}} => Customer Address'}</p>

                            <p className="mc-tab-card-text">{'{{customer_id}} => Customer ID'}</p>
                            <p className="mc-tab-card-text">{'{{customer_email}} => Customer Email'}</p>
                            <p className="mc-tab-card-text">{'{{customer_phone}} => Customer Phone Number'}</p>
                            <p className="mc-tab-card-text">{'{{customer_nationality}} => Customer Nationality'}</p>
                            <p className="mc-tab-card-text">{'{{customer_birth_date}} => Customer Birth Date'}</p>
                            <p className="mc-tab-card-text">{'{{customer_document_number}} => Customer Document Number'}</p>
                            <p className="mc-tab-card-text">{'{{customer_document_expiry_date}} => Customer Document Expiry Date'}</p>
                            <p className="mc-tab-card-text">{'{{customer_occupation}} => Customer Occupation'}</p>
                            <p className="mc-tab-card-text">{'{{customer_document_type}} => Customer Document Type'}</p>
                            <p className="mc-tab-card-text">{'{{customer_is_blocked}} => Customer Is Blocked'}</p>
                            <p className="mc-tab-card-text">{'{{customer_sims_number}} => Customer Sims Number'}</p>
                            <p className="mc-tab-card-text">{'{{customer_type}} => Customer Type'}</p>
                            <p className="mc-tab-card-text">{'{{customer_block_reason}} => Customer Block Reason'}</p>


                            <p className="mc-tab-card-text">{'{{sim_number}} => Sim Card Number'}</p>
                            <p className="mc-tab-card-text">{'{{sim_serial}} => Sim Card Serial Number'}</p>
                            <p className="mc-tab-card-text">{'{{sim_puk}} => Sim Card PUK number'}</p>


                        </div>
                        <div className="mc-tab-card">
                            <Editor
                                editorState={editorState}
                                onEditorStateChange={setEditorState}
                                editorStyle={{
                                    minHeight: "600px",
                                    padding: "10px",
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    resize: "vertical",
                                    overflow: "auto",
                                    }}

                                toolbar={{
                                    image: {
                                        uploadEnabled: true,
                                        uploadCallback: uploadImageCallBack,
                                        previewImage: true,
                                        alt: { present: true, mandatory: false }
                                    }
                                }}
                            />
                        </div>
                        <ButtonComponent className="mc-btn primary" icon="verified" text={t('update')} onClick={()=>handleUpdateButton()}/>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    )
}